import { BadgeVariant } from '../../../../../component-controller-mod/component-serv/badge-fs-cp/dynamic-badge-op/ts/statusBadge';
import { MediaItem } from './mediaData';
import { ApiMediaItem } from './mediaApi';

export function formatBytes(bytes: number): string {
  if (bytes < 1024)        return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-GB', {
    day:   '2-digit',
    month: 'long',
    year:  'numeric',
  });
}

export function toBadgeVariant(status: MediaItem['status']): BadgeVariant {
  switch (status) {
    case 'active':   return 'published';
    case 'deactive': return 'unpublished';
    case 'draft':    return 'draft';
    default:         return 'draft';
  }
}

export function mapStatus(apiStatus: string): MediaItem['status'] {
  const s = apiStatus.toUpperCase();
  if (s === 'PUBLISHED')   return 'active';
  if (s === 'UNPUBLISHED') return 'deactive';
  if (s === 'ARCHIVED')    return 'deactive';
  if (s === 'ACTIVE')      return 'active';
  if (s === 'DRAFT')       return 'draft';
  return 'draft';
}

export function mapApiItem(item: ApiMediaItem): MediaItem {
  const isVideo = item.type === 'VIDEO';
  return {
    id:          String(item.id),
    uuid:        item.uuid ?? '',
    imageSrc:    item.url,
    title:       item.name,
    alt:         item.alt ?? '',
    size:        formatBytes(item.size),
    isVideo,
    mediaType:   isVideo ? 'video' : 'image',
    status:      mapStatus(item.status),
    uploadBy:    'Admin',
    uploadDate:  formatDate(item.createdAt),
    description: item.description ?? '',
  };
}